import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    {/* <Title text="Projects" />
     <Text sx={{ a: {color: `LIGHTSEAGREEN`, fontSize: [1, 2] } }}>
     - [manzan.live](https://manzan.live/) – an online radio station and [API](https://manzan.live/api/v1/docs)
     - [ra-scraper](https://github.com/manuelzander/ra-scraper) – a scraper for [RA](https://www.residentadvisor.net/) using [Scrapy](https://scrapy.org/)
     Can you tell that I like music? 📻 🎧
     </Text> */}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      